import { ParamIds, Places } from 'src/Constants'
import { MainKeys } from 'src/main/Main.keys'

export class serasaHistoryKeys extends MainKeys {
    get place() {
        return Places.mcSerasaHistory
    }

    get startDate() {
        const df = this._intent.getParameterAsString(ParamIds.mcSerasaHistoryStartDate)
        return df ? new Date(df) : undefined
    }

    set startDate(value: Date | undefined) {
        this._intent.setParameter(ParamIds.mcSerasaHistoryStartDate, value?.toISOString())
    }

    get endDate() {
        const df = this._intent.getParameterAsString(ParamIds.mcSerasaHistoryEndDate)
        return df ? new Date(df) : undefined
    }

    set endDate(value: Date | undefined) {
        this._intent.setParameter(ParamIds.mcSerasaHistoryEndDate, value?.toISOString())
    }

    get status() {
        return this._intent.getParameterAsString(ParamIds.mcSerasaHistoryStatus)
    }

    set status(value: string | undefined) {
        this._intent.setParameter(ParamIds.mcSerasaHistoryStatus, value)
    }

    get endpoint() {
        return this._intent.getParameterAsString(ParamIds.mcSerasaHistoryEndpoint)
    }

    set endpoint(value: string | undefined) {
        this._intent.setParameter(ParamIds.mcSerasaHistoryEndpoint, value)
    }
}

export default serasaHistoryKeys
